exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-dice-component-container[data-v-04819011]{position:relative;width:60px;height:60px;top:30px;left:30px;transform-style:preserve-3d}", ""]);

// exports
